import logoIBC from "../../assets/img/Logo IBC.png";
import logoLP from "../../assets/img/LOGO LP.png";
import knowme from "../../assets/img/knowme.png";

function Tools() {
  return (
    <section id="tools" className="mt-6 sm:mt-8 md:mt-10">
      <div className="w-full p-2 sm:p-3 md:p-4">
        <p className="font-extrabold text-xl sm:text-xl md:text-2xl lg:text-2xl text-[#1e72b9] text-center mb-3 sm:mb-4 md:mb-6">
          TECNOLOGÍA E INNOVACIÓN
        </p>
        <p className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#29265b] text-center">
          HERRAMIENTAS QUE IMPULSAN LA CONEXIÓN
        </p>
        <p className="font-medium text-lg sm:text-xl md:text-2xl lg:text-4xl text-[#29265b] text-center mb-8 sm:mb-10 md:mb-14 px-2">
          Tecnología inteligente para networking, negocios y expansión
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6 lg:gap-8 px-4 max-w-6xl mx-auto">
          {/* Launch Pad */}
          <div className="flex flex-col items-center">
            <div className="h-28 sm:h-32 md:h-36 flex items-center justify-center mb-6 sm:mb-8 md:mb-10">
              <a
                href="https://www.launchpadaceleradora.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="w-full max-w-[160px] sm:max-w-[180px] md:max-w-[200px] object-contain"
                  src={logoLP}
                  alt="Logo Launch Pad"
                  loading="lazy"
                />
              </a>
            </div>
            <div className="text-center w-full">
              <a
                href="https://www.launchpadaceleradora.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="font-bold text-base sm:text-lg text-white bg-[#2a3180] hover:bg-[#29265b] transition-colors rounded-full px-4 sm:px-5 md:px-6 py-2 mb-4 sm:mb-5 mx-auto max-w-xs">
                  Aceleradora de Negocios
                </p>
              </a>
              <p className="text-sm sm:text-base text-[#29265b] max-w-xs mx-auto px-2">
                Impulsa tu negocio con nuestra aceleradora empresarial
              </p>
            </div>
          </div>

          {/* IBC Capital */}
          <div className="flex flex-col items-center">
            <div className="h-28 sm:h-32 md:h-36 flex items-center justify-center mb-6 sm:mb-8 md:mb-10">
              <a
                href="https://ibccapital.mx/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="w-full max-w-[200px] sm:max-w-[240px] md:max-w-[280px] object-contain"
                  src={logoIBC}
                  alt="Logo IBC Capital"
                  loading="lazy"
                />
              </a>
            </div>
            <div className="text-center w-full">
              <a
                href="https://ibccapital.mx/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="font-bold text-base sm:text-lg text-white bg-[#2a3180] hover:bg-[#29265b] transition-colors rounded-full px-4 sm:px-5 md:px-6 py-2 mb-4 sm:mb-5 mx-auto max-w-xs">
                  IBC Capital
                </p>
              </a>
              <p className="text-sm sm:text-base text-[#29265b] max-w-xs mx-auto px-2">
                Soluciones financieras para impulsar el crecimiento empresarial
              </p>
            </div>
          </div>

          {/* KNOWME */}
          <div className="flex flex-col items-center">
            <div className="h-28 sm:h-32 md:h-36 flex items-center justify-center mb-6 sm:mb-8 md:mb-10">
              <a
                href="https://knowmeapp.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="w-full max-w-[200px] sm:max-w-[240px] md:max-w-[280px] object-contain"
                  src={knowme}
                  alt="Knowme.app"
                  loading="lazy"
                />
              </a>
            </div>
            <div className="text-center w-full">
              <a
                href="https://knowmeapp.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="font-bold text-base sm:text-lg text-white bg-[#2a3180] hover:bg-[#29265b] transition-colors rounded-full px-4 sm:px-5 md:px-6 py-2 mb-4 sm:mb-5 mx-auto max-w-xs">
                  KNOWME
                </p>
              </a>
              <p className="text-sm sm:text-base text-[#29265b] max-w-xs mx-auto px-2">
                Tarjetas digitales inteligentes para potenciar tu red de
                contactos
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Tools;
